/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} JoinedInputs */

const en_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined`)
};

const es_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se unió`)
};

const fr_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrit`)
};

const de_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beigetreten`)
};

const ja_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録日`)
};

const zh_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入时间`)
};

const ar_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الانضمام`)
};

const id_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabung`)
};

const it_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscritto`)
};

const ru_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата регистрации`)
};

const pt_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro desde`)
};

const ko_joined = /** @type {(inputs: JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가입일`)
};

/**
* | output |
* | --- |
* | "Joined" |
*
* @param {JoinedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const joined = /** @type {((inputs?: JoinedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<JoinedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_joined(inputs)
	if (locale === "es") return es_joined(inputs)
	if (locale === "fr") return fr_joined(inputs)
	if (locale === "de") return de_joined(inputs)
	if (locale === "ja") return ja_joined(inputs)
	if (locale === "zh") return zh_joined(inputs)
	if (locale === "ar") return ar_joined(inputs)
	if (locale === "id") return id_joined(inputs)
	if (locale === "it") return it_joined(inputs)
	if (locale === "ru") return ru_joined(inputs)
	if (locale === "pt") return pt_joined(inputs)
	return ko_joined(inputs)
});